import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { showErrorMessage } from "helpers/toastMessage";
import { AppDispatch } from "store";
import { handleLoading } from "store/global/loader";
import { QUERY_FUNDING_REQUEST_SUMMARY } from "../Broker/ManagePay/query";

export interface ManagePayHistoryState {
  debtor?: string;
  debtorName?: string;
  forceUpdate?: boolean;
}

export function useManagePaySummary() {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const state = location.state as ManagePayHistoryState | undefined;

  const { data, error, loading, refetch } = useQuery(QUERY_FUNDING_REQUEST_SUMMARY, {
    variables: { debtor: state?.debtor },
    fetchPolicy: "cache-and-network"
  });

  useEffect(() => {
    dispatch(handleLoading(loading));
    if (error) showErrorMessage(error.message);
    return () => {
      dispatch(handleLoading(false));
    };
  }, [error, loading, dispatch]);

  const handleSearch = (value: string) => {
    navigate(`${location.pathname}/all`, { state: { ...state, searchValue: value } });
  };

  return {
    state,
    summaryData: data?.fundingRequestsSummary?.data,
    refetch,
    handleSearch
  };
}
